var map = {
	"./Aegteskab.svg": 11467,
	"./Afkast_rente.svg": 46455,
	"./Alderspension.svg": 32695,
	"./Balance.svg": 46964,
	"./Barnevogn.svg": 54978,
	"./Beregner.svg": 70490,
	"./Biomasseanlaeg.svg": 34195,
	"./Blade.svg": 90902,
	"./Boern.svg": 19390,
	"./CO2_groen.svg": 24274,
	"./Chat.svg": 99042,
	"./Delpension.svg": 11459,
	"./Deportrente.svg": 24554,
	"./Doed.svg": 11008,
	"./E-post.svg": 31048,
	"./Efterloen.svg": 28060,
	"./Familie.svg": 59645,
	"./Flueben.svg": 29479,
	"./Fritid.svg": 7080,
	"./Genbrug.svg": 60174,
	"./Graf1.svg": 77591,
	"./Graf2.svg": 34468,
	"./Groenne_aktier.svg": 655,
	"./Groenne_ejendomme.svg": 60283,
	"./Haengelaas.svg": 54205,
	"./Hjerte.svg": 79562,
	"./Husstand.svg": 54748,
	"./I_arbejde.svg": 98381,
	"./Indbakke_beskeder.svg": 46561,
	"./Indbakke_dokumenter.svg": 25196,
	"./Jordklode.svg": 78500,
	"./Kvinde.svg": 6939,
	"./Livsvsarig.svg": 65435,
	"./Lyspaere.svg": 71985,
	"./Mand.svg": 21232,
	"./Mobil.svg": 98377,
	"./Mobil_haand.svg": 10352,
	"./Moent.svg": 25415,
	"./Opsparing.svg": 44091,
	"./Overblik.svg": 76220,
	"./Papirbunke.svg": 45097,
	"./Papirflyver.svg": 91360,
	"./Par.svg": 99249,
	"./Pengesaek.svg": 35249,
	"./Pengesaek_haand.svg": 33832,
	"./Pengeseddel.svg": 89322,
	"./Pengestabel.svg": 69098,
	"./Pensionist_kvinde.svg": 24602,
	"./Pensionist_mand.svg": 58877,
	"./Pensionstjek.svg": 29983,
	"./Person.svg": 89263,
	"./Person_spoergsmaal.svg": 84236,
	"./Person_syg.svg": 59653,
	"./Planlaegning.svg": 73606,
	"./Post.svg": 48214,
	"./Raadgiver.svg": 81107,
	"./Rapport.svg": 25144,
	"./Rate.svg": 42286,
	"./Risiko.svg": 38905,
	"./Samlepension.svg": 76926,
	"./Seddelstabel.svg": 8720,
	"./Skilsmisse.svg": 62085,
	"./Skydeskive.svg": 69154,
	"./Sol.svg": 29766,
	"./Solcelle.svg": 53991,
	"./Speaker.svg": 67219,
	"./Spoergsmaalstegn.svg": 49639,
	"./Stemmeseddel.svg": 12834,
	"./Sygdom.svg": 50137,
	"./Tablet.svg": 21760,
	"./Tablet_haand.svg": 76441,
	"./ThumbsUp.svg": 10348,
	"./To_der_taler_sammen.svg": 63804,
	"./Trae.svg": 91468,
	"./Udraabstegn.svg": 51794,
	"./Vindmoelle.svg": 86323,
	"./Virksomhed_menneskerettigheder.svg": 54640,
	"./Virksomhed_vaaben.svg": 46320,
	"./Virksomheder_forurener.svg": 56296,
	"./Virksomheder_korruption.svg": 92035,
	"./Virksomheder_tobak.svg": 87831,
	"./Website.svg": 95375,
	"./dialog.svg": 72608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86972;